import { create360User } from '../services';
export async function createAppUser(userPayload) {
    const response = await create360User(userPayload);
    return formatResponse(response);
}
function formatResponse({ success, data, errors }) {
    if (!success) {
        return {
            success: false,
            error: errors.code,
        };
    }
    return {
        success: true,
        data: {
            result: data.result,
            userId: data.userId,
            sellerId: data.sellerId,
        },
    };
}
